import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';
import { Icon } from 'front-onceforall-core';
import { getFieldLabel } from '../../../utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Contact(_ref) {
  let {
    onChange,
    contact,
    deleteContact
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "card",
    children: /*#__PURE__*/_jsxs("div", {
      className: "row",
      children: [/*#__PURE__*/_jsx("div", {
        className: "col-lg-4 col-md-4 col-sm-6 col-xs-12 pb-3",
        children: /*#__PURE__*/_jsx(TextField, {
          label: getFieldLabel('publicProcurement.contact.firstName', true),
          id: "contact-firstName",
          name: "contact-firstName",
          value: contact.firstName || '',
          onChange: onChange('firstName')
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "col-lg-4 col-md-4 col-sm-6 col-xs-12 pb-3",
        children: /*#__PURE__*/_jsx(TextField, {
          label: getFieldLabel('publicProcurement.contact.lastName', true),
          id: "contact-lastName",
          name: "contact-lastName",
          value: contact.lastName || '',
          onChange: onChange('lastName')
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "col-lg-3 col-md-3 col-sm-10 col-xs-9 pb-3",
        children: /*#__PURE__*/_jsx(TextField, {
          label: getFieldLabel('publicProcurement.contact.jobTitle', true),
          id: "contact-jobTitle",
          name: "contact-jobTitle",
          value: contact.jobTitle || '',
          onChange: onChange('jobTitle')
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "col-lg-1 col-md-1 col-sm-2 col-xs-3 pb-3 d-flex align-items-center",
        children: /*#__PURE__*/_jsx("button", {
          className: "small primary",
          id: "delete-contact",
          type: "button",
          onClick: deleteContact,
          children: /*#__PURE__*/_jsx(Icon, {
            icon: "trash"
          })
        })
      })]
    })
  });
}
Contact.defaultProps = {
  contact: {
    firstName: '',
    lastName: '',
    jobTitle: ''
  }
};
Contact.propTypes = {
  onChange: PropTypes.func.isRequired,
  deleteContact: PropTypes.func.isRequired,
  contact: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    jobTitle: PropTypes.string
  })
};
export default Contact;